import { DropShadowFilter } from "pixi-filters";
import Layers from "slotworks/graphics/layers/layers";
import SGGameScenes from "model/sg-game-scenes";
import Scene from "slotworks/graphics/layers/scene";

class TextStylePatch {
    public applyCelebrationTextStyle(...textElements: PIXI.Text[]): void {
        for (const element of textElements) {
            if (!element) {
                continue;
            }

            const filters = [];
            for (let i = 0; i < 3; i++) {
                const glow: DropShadowFilter = new DropShadowFilter();
                glow.color = 0x260800;
                glow.rotation = 90;
                glow.distance = 3;
                glow.alpha = 1;
                glow.blur = 10 + i * 3;
                glow.pixelSize = 0.3;
                glow.quality = 5;
                filters.push(glow);
            }

            element.filters = filters;
        }
    }

    init() {
        Layers.Prompts.onSceneEnter.add((scene: string) => {
            if (scene === SGGameScenes.FREE_SPINS_WIN || scene === SGGameScenes.FREE_SPINS_SUMMARY) {
                const text = scene === SGGameScenes.FREE_SPINS_WIN ? "winMessage" : "value";
                const value = Layers.Prompts.getText(text);
                this.applyCelebrationTextStyle(value);
            }
        });
    }

}

export default new TextStylePatch();
